import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-member" }
const _hoisted_2 = { class: "flex flex-row gap-4" }

import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

import { maskDateBR } from "@/common/utils/mask";

import type { MemberType } from "@/common/types/member";

import { baseInput } from "@/common/components";

interface MemberRegisterType {
  name: string;
  login: string;
  email: string;
  birthdate: string;
  password: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'form-member',
  props: {
    data: {},
    isPatch: { type: Boolean },
    isEdit: { type: Boolean }
  },
  emits: ["update:data", "validate"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
  name: "",
  login: "",
  email: "",
  birthdate: "",
  password: Math.random().toString(36).slice(-10),
};

const payload = ref<MemberRegisterType>({ ...DEFAULT_DATA });
const errors = ref<{ [key: string]: string }>({});

function validate() {
  const free = ["password"];

  Object.keys(payload.value).forEach((key) => {
    delete errors.value[key];

    if (!payload.value[key] && !free.includes(key))
      errors.value[key] = t("error.required");
  });

  emit("validate", Object.keys(errors.value).length === 0);
}

function update(key: keyof typeof payload.value) {
  validate();

  if (props.isPatch) {
    if (payload.value[key] === props.data[key]) return;

    emit("update:data", { [key]: payload.value[key] });
    return;
  }

  emit("update:data", payload.value);
}

function resumeData() {
  if (!props.data) return;

  const { first_name, last_name, email, login } = props.data;

  payload.value = {
    ...payload.value,
    name: `${first_name ?? ""} ${last_name ?? ""}`,
    email,
    login,
  };
}

watch(
  () => props.data,
  () => {
    resumeData();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
      value: payload.value.name,
      placeholder: _unref(t)('common.placeholders.name'),
      required: "",
      maxlength: "75",
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (update('name')))
    }, _createSlots({
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
      ]),
      _: 2
    }, [
      (errors.value.name)
        ? {
            name: "error",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(errors.value.name), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "value", "placeholder"]),
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.email,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.email) = $event)),
      value: payload.value.email,
      placeholder: _unref(t)('common.placeholders.email'),
      required: "",
      maxlength: "100",
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (update('email')))
    }, _createSlots({
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.email")) + " *", 1)
      ]),
      _: 2
    }, [
      (errors.value.email)
        ? {
            name: "error",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(errors.value.email), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "value", "placeholder"]),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.login,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.login) = $event)),
        value: payload.value.login,
        placeholder: _unref(t)('common.placeholders.login'),
        required: "",
        maxlength: "75",
        onBlur: _cache[5] || (_cache[5] = ($event: any) => (update('login')))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.login")) + " *", 1)
        ]),
        _: 2
      }, [
        (errors.value.login)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.login), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.birthdate,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.birthdate) = $event)),
        value: payload.value.birthdate,
        mask: _unref(maskDateBR),
        placeholder: "dd/mm/yyyy",
        minLength: "10",
        maxLength: "10",
        onBlur: _cache[7] || (_cache[7] = ($event: any) => (update('birthdate')))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.birthdate")) + " * ", 1)
        ]),
        _: 2
      }, [
        (errors.value.birthdate)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.birthdate), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value", "mask"])
    ])
  ]))
}
}

})